import React, { FC, useEffect, useMemo, useState } from "react";
import Config from "../../config/Config";
import { useAppDispatch, useAppSelector } from "../../core/feature/hooks";
import User from "../../core/models/user";
import TabsMobile from "../__template/TabsMobileComponent";
// import users from "../../assets/images/icon_profile/user.svg";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useTranslation } from "react-i18next";
// import clock from "../../assets/images/clock.svg";
import clock from "../../assets/images/clock.svg";
import arrowUp from "../../assets/images/arrow-up.svg";
import { Tab } from "@headlessui/react";
import DatePicker from "react-datepicker";
import * as API from "../../core/service/api_attendance.js";
import CustomApp from "../../core/models/customApp";
import { setLoading } from "../../core/feature/config/configSlice";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import { Parallax } from "react-scroll-parallax";
import { LazyLoadImage } from "react-lazy-load-image-component";

interface HistoryAttendanceProps {
  callerId?: string;
}

const ComponentHistoryAttendance: FC<HistoryAttendanceProps> = (
  props,
): JSX.Element => {
  const user: User = useAppSelector((state) => state.user.user);
  const navigate = useNavigate();
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp,
  );
  const dispatch = useAppDispatch();
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const [startDate, setStartDate] = useState(
    new Date(currentYear, currentMonth, 1),
  );
  const [statistic, setStatistic] = useState<any>({});
  const [statisticDetail, setStatisticDetail] = useState<any>([]);
  const [detail, setDetail] = useState<any>({});
  const [openDetailHistory, setOpenDetailHistory] = useState(false);
  const [page, setPage] = useState(0);
  const [indexes, setIndexes] = useState(0);
  const [size, setSize] = useState(5);
  const [activeCallerId, setActiveCallerId] = useState<string | undefined>(
    props.callerId,
  );
  const { t } = useTranslation();
  const labels: any = {
    totalSakit: "Sakit",
    totalIzin: "Ijin",
    totalAlpa: "Alpa",
    totalAttendance: "Hadir",
    totalTerlambat: "Terlambat",
    totalOnsite: "On Site",
  };

  const currentStatisticDetail = useMemo(() => {
    const a = statisticDetail.length;
    const b = a / (page + 1);

    return b;
  }, [statisticDetail]);

  const getStatistic = () => {
    let startDateFilter = moment(startDate).format("YYYY-MM-DD");
    let endDateFilter = moment(startDate).add(29, "days").format("YYYY-MM-DD");

    API.getAttendanceStatistic(startDateFilter, endDateFilter, activeCallerId)
      .then((res) => {
        setStatistic(res.data.content.length ? res.data.content[0] : {});
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const getStatisticDetail = () => {
    dispatch(setLoading(true));
    console.log("[ACTIVE CALLER ID]: ", activeCallerId);
    console.log("======================");
    console.log("[props.callerId]: ", props.callerId);

    let startDateFilter = moment(startDate).format("YYYY-MM-DD");
    let endDateFilter = moment(startDate).add(29, "days").format("YYYY-MM-DD");
    API.getAttendanceProDetail(
      size,
      page,
      startDateFilter,
      endDateFilter,
      activeCallerId,
    )
      .then((res) => {
        dispatch(setLoading(false));
        setStatisticDetail(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
      });
  };

  const addMoreDetail = async () => {
    setPage((prevPage) => prevPage + 1); // Update page
    setIndexes((prevIndexes) => prevIndexes + 10); // Update indexes

    const startDateFilter = moment(startDate).format("YYYY-MM-DD");
    const endDateFilter = moment(startDate)
      .add(29, "days")
      .format("YYYY-MM-DD");

    try {
      const res = await API.getAttendanceProDetail(
        size,
        page + 1,
        startDateFilter,
        endDateFilter,
        activeCallerId,
      );

      // Update statisticDetail by concatenating the new data
      setStatisticDetail(statisticDetail.concat(res.data.content));

      console.log(res.data);
    } catch (err) {
      // Handle error if needed
    }
  };

  function onDismissDetailHistory() {
    setOpenDetailHistory(false);
  }

  const openSheetDetailHistory = async () => {
    setOpenDetailHistory(true);
  };

  useEffect(() => {
    if (props.callerId) {
      setActiveCallerId(props.callerId);
    } else if (!activeCallerId) {
      const identities = user?.accounts?.[0]?.callerIdentities ?? [];
      if (identities.length === 1) {
        setActiveCallerId(identities[0].callerId);
      }
    }
  }, [props.callerId, user, activeCallerId]);

  useEffect(() => {
    if (activeCallerId) {
      getStatistic();
      getStatisticDetail();
    }
  }, [startDate, props.callerId]);

  const formatStatus = (text?: string) => {
    if (!text) {
      return "-";
    }
    return text
      .split("_")
      .map((word) => word.toLowerCase())
      .map((word) => (word ? word[0].toUpperCase() + word.slice(1) : ""))
      .join(" ");
  };

  const isLate = detail?.tapInInformation?.includes("TERLAMBAT");
  const isEarlyCheckout = detail?.tapOutInformation?.includes("AWAL");
  const isAlpa = detail?.information === "ALPA";

  return (
    <div>
      <BottomSheet
        className="z-[99]"
        open={openDetailHistory}
        onDismiss={onDismissDetailHistory}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ minHeight, maxHeight }) => [minHeight, maxHeight / 0.6]}
        header={
          <h1 className="font-poppins flex items-left text-xs  font-bold text-black">
            {moment(detail.attendanceDate).format("DD MMMM YYYY")}
          </h1>
        }
      >
        <div className="px-4 pt-2 pb-4">
          <div className="space-y-3 mb-3">
            <div className="bg-white rounded-lg shadow-sm p-3">
              <p className="font-montserrat font-semibold text-xs text-slate-700 mb-2">
                Absen Masuk
              </p>
              {detail.tapInPhotoUrl && (
                <div className="flex items-start gap-3">
                  <img
                    width="100px"
                    height="100px"
                    alt="Tap In Photo"
                    src={detail.tapInPhotoUrl}
                    style={{ borderRadius: "12px" }}
                  />
                </div>
              )}
              <div className="mt-2 space-y-1">
                <div className="grid grid-cols-[90px_1fr] items-center gap-2">
                  <p className="font-montserrat mt-2 font-medium text-xs text-slate-500">
                    Nama Shift
                  </p>
                  <p className="font-montserrat font-medium text-xs text-slate-500 truncate">
                    {detail.shiftName}
                  </p>
                </div>
                <div className="grid grid-cols-[90px_1fr] items-center gap-2">
                  <p className="font-montserrat mt-2 font-medium text-xs text-slate-500">
                    Keterangan
                  </p>
                  <p
                    className={`font-montserrat font-bold text-xs truncate ${
                      detail.information === "ALPA"
                        ? "text-red"
                        : "text-green-500"
                    }`}
                  >
                    {detail.information}
                  </p>
                </div>
              </div>
              <div
                className={`grid grid-cols-3 gap-2 mt-2 items-center rounded-md px-2 py-1 ${
                  isLate
                    ? "bg-red bg-opacity-25"
                    : isAlpa
                      ? "bg-red bg-opacity-25"
                      : "bg-green-500/10"
                }`}
              >
                <p className="font-montserrat text-black text-xs text-left leading-4">
                  {detail.startTime ? detail.startTime : "-"}
                </p>
                <p className="font-montserrat text-black text-xs text-center leading-4">
                  Clock In
                </p>
                <p className="font-montserrat text-black text-xs text-right leading-4">
                  {formatStatus(detail.tapInInformation)}
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm p-3">
              <p className="font-montserrat font-semibold text-xs text-slate-700 mb-2">
                Absen Pulang
              </p>
              {detail.tapOutPhotoUrl && (
                <div className="flex items-start gap-3">
                  <img
                    width="100px"
                    height="100px"
                    alt="clock out photo"
                    src={detail.tapOutPhotoUrl}
                    style={{ borderRadius: "12px" }}
                  />
                </div>
              )}
              <div className="mt-2 space-y-1">
                <div className="grid grid-cols-[90px_1fr] items-center gap-2">
                  <p className="font-montserrat mt-2 font-medium text-xs text-slate-500">
                    Nama Shift
                  </p>
                  <p className="font-montserrat font-medium text-xs text-slate-500 truncate">
                    {detail.shiftName}
                  </p>
                </div>
                <div className="grid grid-cols-[90px_1fr] items-center gap-2">
                  <p className="font-montserrat mt-2 font-medium text-xs text-slate-500">
                    Keterangan
                  </p>
                  <p
                    className={`font-montserrat font-bold text-xs truncate ${
                      detail.information === "ALPA"
                        ? "text-red"
                        : "text-green-500"
                    }`}
                  >
                    {detail.information}
                  </p>
                </div>
              </div>
              <div
                className={`grid grid-cols-3 gap-2 mt-2 items-center rounded-md px-2 py-1 ${
                  isEarlyCheckout
                    ? "bg-red bg-opacity-25"
                    : isAlpa
                      ? "bg-red bg-opacity-25"
                      : "bg-green-500/10"
                }`}
              >
                <p className="font-montserrat text-black text-xs text-left leading-4">
                  {detail.endTime ? detail.endTime : "-"}
                </p>
                <p className="font-montserrat text-black text-xs text-center leading-4">
                  Clock Out
                </p>
                <p className="font-montserrat text-black text-xs text-right leading-4">
                  {formatStatus(detail.tapOutInformation)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </BottomSheet>
      <h1 className="font-bold text-sm font-montserrat grow">Filter Tanggal</h1>
      <DatePicker
        wrapperClassName="w-full"
        disabled={!activeCallerId}
        className="w-full h-10 text-sm px-2 border-2 border-solid border-psp-gray rounded-lg"
        selected={startDate}
        onChange={(date: Date) => setStartDate(date)}
        showMonthYearPicker
        dateFormat="MMMM yyyy"
      />
      {statistic && Object.keys(statistic).length === 0 ? (
        <div className="flex justify-center my-3">
          <span className="font-normal text-xs text-center">
            {t("OTHER.dataNotFound")}
          </span>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-md font-montserrat my-3 relative">
          <div className="px-4 pt-2 ">
            <div className="grid grid-row-2 divide-y ">
              <h1 className="m-0 font-bold text-sm font-montserrat grow">
                Rekapitulasi
                <hr className="my-2" />
              </h1>
            </div>
            <div className="grid grid-cols-3 gap-0">
              {Object.entries(statistic).map(([key, value]) => {
                if (labels[key]) {
                  return (
                    <div className="flex no-underline w-full justify-center">
                      <div className="flex flex-col items-center  w-fit">
                        <p className="text-center font-light text-xs text-slate-400 mb-0">
                          {labels[key]}
                        </p>
                        <p className="text-center font-bold text-sm">
                          {value as React.ReactNode}
                        </p>
                      </div>
                    </div>
                  );
                }
                return null;
              })}
            </div>
          </div>
          <Parallax
            speed={0}
            className="absolute bottom-0 right-0 z-10"
            style={{ zIndex: 0 }}
          >
            <LazyLoadImage
              className="inline rounded-xl"
              effect="blur"
              src={clock}
            />
          </Parallax>
        </div>
      )}

      {!statisticDetail.length
        ? null
        : statisticDetail.map((data: any, index: any) => {
            return (
              <div
                key={index}
                className="bg-white rounded-xl shadow-md my-3 px-2 py-2 flex justify-between"
                onClick={() => {
                  openSheetDetailHistory();
                  setDetail(data);
                }}
              >
                <div className="flex flex-col w-1/4">
                  <p className="text-xs font-medium mb-0 w-full font-montserrat ">
                    {moment(data.attendanceDate).format("DD MMMM")}
                  </p>
                  <p className="font-light text-[10px] text-slate-400 mb-0 truncate">
                    {data.shiftName}
                  </p>
                </div>
                <div className="flex flex-col w-1/4">
                  <p className="text-xs font-medium mb-0 w-full font-montserrat truncate">
                    {data.tapInTime ? data.tapInTime : "-"}
                  </p>
                  <p className="font-light text-[10px] text-slate-400 mb-0">
                    Absen Masuk
                  </p>
                </div>

                <div className="flex flex-col w-1/4">
                  <p className="text-xs font-medium mb-0 w-full font-montserrat truncate">
                    {data.tapOutTime ? data.tapOutTime : "-"}
                  </p>
                  <p className="font-light text-[10px] text-slate-400 mb-0">
                    Absen Pulang
                  </p>
                </div>
                <div className="flex flex-col items-center">
                  <img
                    src={arrowUp}
                    style={{ width: 25, height: 25 }}
                    className="m-auto"
                  />
                </div>
              </div>
            );
          })}
      {currentStatisticDetail < 5 ? (
        ""
      ) : (
        <div className="flex w-full">
          <button
            onClick={addMoreDetail}
            style={{ color: customApp?.app_accent_color }}
            className="w-full transparent px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active "
          >
            {t("OTHER.showMore")}
          </button>
        </div>
      )}
    </div>
  );
};

export default ComponentHistoryAttendance;
